module.exports = __webpack_public_path__ + "img/icon_map_1_yj_c.6fd6a99a.png";